import React from 'react';
import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { colors, radii } from '../../styles/tokens';

export interface TopicPillProps {
  label: string;
  active?: boolean;
  onClick?: () => void;
  icon?: React.ReactElement;
}

// Deliberately not instrumented: this chip is also used for tool shortcuts and
// plain navigation, so a topic_click fired from here mislabels those. Callers
// that really are topics fire the event themselves.
export const TopicPill: React.FC<TopicPillProps> = ({ label, active = false, onClick, icon }) => {
  return (
    <Chip
      label={label}
      icon={icon}
      onClick={onClick}
      clickable={Boolean(onClick)}
      sx={{
        height: 34,
        px: 0.5,
        fontSize: '0.8125rem',
        fontWeight: 600,
        borderRadius: `${radii.badge}px`,
        border: `1px solid ${active ? colors.primary : colors.border}`,
        bgcolor: active ? alpha(colors.primary, 0.1) : colors.paper,
        color: active ? colors.primary : colors.textSecondary,
        transition: 'background-color 150ms ease, border-color 150ms ease, color 150ms ease',
        '& .MuiChip-icon': {
          color: 'inherit',
          fontSize: 18,
        },
        '&:hover': {
          bgcolor: active ? alpha(colors.primary, 0.14) : alpha(colors.primary, 0.06),
          borderColor: colors.primary,
          color: colors.primary,
        },
      }}
    />
  );
};
